import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import { Popover, Button, Space, Input, Select, message } from 'udesk-ui';
import UdeskTable from 'Component/common/udesk-table';
import UdeskPagination from 'Component/common/udesk-pagination';
import CustomFilterModal from 'Component/pages/components/custom-filter-modal';
import CustomSortModal from 'Component/pages/components/custom-sort-modal';
import ListManageComponent from './component';
import ExportButton from 'Component/common/export-button';
import { BatchedActions } from 'udesk_gm_ui';
import AddToTaskModal from '../AddToTaskModal';
import { ArrowDownSOutlined } from '@udesk/icons';
import { postCallManageBatchReAsr } from 'src/api/call/manage/batch/reAsr';
import { postAsrFilterConfigRedo } from 'src/api/asr-filter-config/redo';
import { postCalltaskBatchReTranslate } from 'src/api/calltask/batch/reTranslate';
import { getSystemModule } from 'Udesk/system/subApp';
import LanguageSelect from 'Component/pages/components/LanguageSelect';
import { hasDuplicateValuesByProperty } from 'src/util/hasDuplicateValuesByProperty';
import _isEmpty from 'lodash-es/isEmpty';
import { taskSuccessNotification } from 'Component/common/export-button';
import './style.scss';

export default class ListManageTemplate extends ListManageComponent {
    render() {
        let {
            // sdkOptions,
            title,
            cacheKey,
            searchPlaceHolder,
            isWechatQa,
            hideKeywordType,
        } = this.props;
        let {
            judgeStrategy,
            customJudgeLogic,
            data,
            customName,
            customId,
            conditionList,
            tableDOMRef,
            tableRef,
            loading,
            selectedItems,
            addToTaskModalVisible,
            _isSortVisible,
            sortList,
        } = this.privates;
        let {
            searchField,
            paging,
            // type,
            keywordType,
            callLang,
        } = this.privates.storages;
        let { _columns, _isFilterVisible, _selectedLang } = this.privates.computes;
        let { actions, locales } = this;

        let customCard = (
            <div className="custom-filter-info-type">
                <div className="index-management-custom-filter-Info">
                    <div>
                        {locales.components.common.customFilter.customFilterCondition}：
                        {_isEmpty(conditionList) && locales.components.common.customFilter.none}
                    </div>
                    <div>
                        {!_isEmpty(conditionList) &&
                            this.actions.fieldsFilterChange({ conditionList })}
                    </div>
                </div>
                <div>
                    {locales.components.common.customFilter.conditionRule}：
                    <span>
                        {judgeStrategy !== 3 &&
                            Udesk.enums.operatorRuleTypes.find(
                                (current) => current.id === judgeStrategy
                            ).name}
                        {judgeStrategy === 3 && customJudgeLogic}
                    </span>
                </div>
            </div>
        );

        const actionMenu = [
            {
                label: /* 添加至质检任务 */ locales.components.listManage.template
                    .addToQualityInspectionTask,
                onClick: (item) => {
                    const hasDuplicate = hasDuplicateValuesByProperty(
                        this.privates.selectedItems || [],
                        'lang'
                    );

                    if (hasDuplicate) {
                        message.warning(
                            /* 选中数据语言不一致，无法添加至质检任务 */ UdeskLocales['current']
                                .components.listManage.template
                                .theSelectedDataLanguageIsInconsistentAndCannotBeAddedToTheQualityInspectionTask
                        );
                    } else {
                        this.privates.addToTaskModalVisible = true;
                        this.actions.update();
                    }
                },
                isShow: Number(this.props.type) === Udesk.enums.inspectDataSources.voiceCall.id,
            },
            {
                label: /* 重新识别 */ UdeskLocales['current'].components.listManage.template
                    .reIdentification,
                confirm: {
                    title: /* 重新识别会消耗转写时长，请谨慎操作 */ UdeskLocales['current']
                        .components.listManage.template
                        .rerecognitionWillConsumeTranscriptionTimePleaseOperateWithCaution,
                    okText: /* 确定 */ UdeskLocales['current'].components.listManage.template
                        .determine,
                },
                onClick: (item) => {
                    postCallManageBatchReAsr(
                        {
                            callIdList: selectedItems.map((i) => i.dataId),
                            systemModule: getSystemModule(),
                        },
                        {
                            successMsg:
                                /* 执行成功 */ UdeskLocales['current'].components.listManage
                                    .template.executionSuccessful,
                        }
                    ).then(() => {
                        taskSuccessNotification();
                    })  ;
                },
                isShow: Number(this.props.type) === Udesk.enums.inspectDataSources.voiceCall.id,
            },
            {
                label: /* 重新纠错 */ UdeskLocales['current'].components.listManage.template
                    .reerrorCorrection,
                confirm: {
                    title: /* 确定要重新纠错吗？ */ UdeskLocales['current'].components.listManage
                        .template.areYouSureYouWantToRecorrectTheError,
                    okText: /* 确定 */ UdeskLocales['current'].components.listManage.template
                        .determine,
                },
                onClick: (item) => {
                    postAsrFilterConfigRedo(
                        {
                            callIds: selectedItems.map((i) => i.dataId),
                            systemModule: getSystemModule(),
                        },
                        {
                            successMsg:
                                /* 执行成功 */ UdeskLocales['current'].components.listManage
                                    .template.executionSuccessful,
                        }
                    ).then(() => {
                        taskSuccessNotification();
                    });
                },
                isShow: Number(this.props.type) === Udesk.enums.inspectDataSources.voiceCall.id,
            },
            {
                label: /* 重新翻译 */ UdeskLocales['current'].components.listManage.template
                    .retranslation,
                confirm: {
                    title: /* 确定要重新翻译吗？ */ UdeskLocales['current'].components.listManage
                        .template.areYouSureYouWantToRetranslate,
                    okText: /* 确定 */ UdeskLocales['current'].components.listManage.template
                        .determine,
                },
                onClick: (item) => {
                    postCalltaskBatchReTranslate(
                        {
                            callDataIds: selectedItems.map((i) => i.dataId),
                            systemModule: getSystemModule(),
                        },
                        {
                            successMsg:
                                /* 执行成功 */ UdeskLocales['current'].components.listManage
                                    .template.executionSuccessful,
                        }
                    ).then(() => {
                        taskSuccessNotification();
                    });
                },
                isShow: true,
            },
        ].filter((item) => item.isShow);

        return (
            <div className="qa-react-list-page">
                <div className="qa-react-list-page-header">
                    <div className="qa-react-list-page-header-title">{title}</div>
                </div>
                <div className="qa-react-list-page-body">
                    <div className="qa-react-list-page-functions">
                        <If condition={!isWechatQa}>
                            <div className="qa-react-list-page-functions-left-part pull-left">
                                <Space>
                                    {!hideKeywordType ? (
                                        <Select
                                            value={keywordType}
                                            style={{ width: 100 }}
                                            onSelect={actions.selectType}
                                            disabled={loading}
                                            options={Udesk.enums.applyRolesWithRobot.map((i) => ({
                                                label: i.name,
                                                value: i.keywordType,
                                            }))}
                                        />
                                    ) : null}

                                    <Input
                                        maxCount={20}
                                        showCount={true}
                                        maxLength={20}
                                        value={searchField}
                                        placeholder={searchPlaceHolder}
                                        onChange={actions.changeSearchField}
                                        disabled={loading}
                                    />

                                    <LanguageSelect
                                        value={callLang}
                                        onChange={actions.onLanguageChange}
                                        allowClear
                                    />

                                    <Button onClick={actions.searchItems} disabled={loading}>
                                        {locales.labels.query}
                                    </Button>
                                </Space>
                            </div>
                        </If>
                        <div className="qa-react-list-page-functions-right-part pull-right">
                            <Space>
                                <BatchedActions menu={actionMenu} disabled={!selectedItems.length}>
                                    <Button disabled={!selectedItems.length}>
                                        {/* 批量操作 */}
                                        {locales.components.listManage.template.batchOperation}
                                        <ArrowDownSOutlined style={{ marginLeft: 4 }} />
                                    </Button>
                                </BatchedActions>

                                <Button onClick={actions.changeSortVisible} disabled={loading}>
                                    {/* 排序 */}
                                    {UdeskLocales['current'].components.listManage.template.sort}
                                </Button>
                                <Popover content={customCard} placement="bottomRight">
                                    <Button
                                        onClick={actions.changeFilterVisible}
                                        disabled={loading}
                                    >
                                        {locales.labels.filter}
                                    </Button>
                                </Popover>
                                {!this.props.hiddenExportBtn && (
                                    <ExportButton
                                        disabled={loading}
                                        exportDataCount={paging.total}
                                        hasFilterCondition={!!conditionList.length}
                                        onClick={actions.exportCallList}
                                    />
                                )}
                                <Button onClick={actions.onPopoverVisible}>
                                    {locales.components.pages.customerServiceRankList.select.column}
                                </Button>
                            </Space>
                        </div>
                    </div>
                    <div ref={tableDOMRef} className="qa-react-list-page-content">
                        <UdeskTable
                            subtractedHeight={197}
                            // horizontalScrollbar={true}
                            // showHorizontalScrollbar={true}
                            columns={_columns}
                            loading={loading}
                            ref={tableRef}
                            cacheKey={cacheKey}
                            dataSource={data?.fieldDataList ?? []}
                            // enableChooseColumns={true}
                            // rowClick={actions.gotoDetail}
                            onRow={(record, index) => {
                                return { onClick: actions.gotoDetail.params(record) };
                            }}
                            pagination={false}
                            rowSelection={{
                                selectedRowKeys: selectedItems.map((i) => i.dataId),
                                onSelect: actions.onSelectChange,
                                onSelectAll: actions.onSelectAllChange,
                            }}
                            // onColumnsChanged={actions.onColumnsChanged}
                        />
                    </div>
                </div>
                <div className="qa-react-list-page-footer">
                    <If condition={data && data.fieldDataList && data.fieldDataList.length > 0}>
                        {/* <ReactPager
                            showTotalPages={false}
                            pageRangeDisplayed={1}
                            marginPagesDisplayed={0}
                            pageSize={paging.pageSize}
                            total={paging.total}
                            pageNum={paging.pageNum}
                            languageCode={sdkOptions.props.language}
                            pageChanged={actions.pageChanged}
                        /> */}
                        <UdeskPagination
                            current={paging.pageNum}
                            pageSize={paging.pageSize}
                            total={paging.total}
                            onChange={actions.pageChanged}
                        />
                    </If>
                </div>
                <AddToTaskModal
                    visible={addToTaskModalVisible}
                    inspectDataSource={Number(this.props.type)}
                    onAdded={actions.close}
                    onCancel={actions.close}
                    dataId={selectedItems.map((i) => i.dataId)}
                    lang={_selectedLang}
                />
                <CustomFilterModal
                    visible={_isFilterVisible}
                    applyAction={actions.handleConditionApply}
                    judgeStrategy={judgeStrategy}
                    customJudgeLogic={customJudgeLogic}
                    conditionList={conditionList}
                    customName={customName}
                    customId={customId}
                    onConditionFilterSaved={this.props.onConditionFilterSaved}
                    cancel={actions.handleConditionCancelWithoutClearData}
                    type={this.props.type}
                    filterList={['f_8']}
                    filterInspectData
                    filterType={Udesk.enums.customFilterListType.datasourceManagement.id}
                    onSetDefault={this.props.onSetDefault}
                />
                <CustomSortModal
                    visible={_isSortVisible}
                    judgeStrategy={judgeStrategy}
                    customJudgeLogic={customJudgeLogic}
                    conditionList={sortList}
                    onConditionFilterSaved={this.props.onConditionFilterSaved}
                    cancel={actions.handleConditionCancelWithoutClearData}
                    applyAction={actions.handleSortApply}
                    type={this.props.type}
                    filterList={['f_8']}
                    filterInspectData
                />
            </div>
        );
    }
}
